// 工单
export const workOrderApi = {
    getOrderList: "/api/workorder", // 工单列表 工单详情
    getOrderState: "/api/workorder/status_types/tabs", // 工单状态tabs
    getOrderTypeCategories: "/api/workorder/types/group_by_category", // 获取工单状态分类列表
    getOrderAction: "/api/workorder/search_types", // 工单操作人相关
    postLogin: "/api/v1/login", // 工单操作人相关

};
// 上传
export const uploadUrl = "/Data/upload.ashx?Action=file";

export const erpDataApiDic = {

    getAuditSetList: "/Data/module_audit.ashx?Action=GetAuditSetList",
    addAuditSet: "/Data/module_audit.ashx?Action=AuditSetAdd",
    updateAuditSet: "/Data/module_audit.ashx?Action=AuditSetUpdate",
    deleteAuditSet: "/Data/module_audit.ashx?Action=AuditSetDelete",
    deleteAuditSetProcess: "/Data/module_audit.ashx?Action=AuditSetAuditProcessDelete",

    getVillageDetail: "/Data/villages.ashx?action=GetVillageDetail",
    updateVillage: "/Data/villages.ashx?action=VillagesUpdate",
    getDepartmentDetail: "/Data/department.ashx?action=GetDepartmentDetail",
    updateDepartment: "/Data/department.ashx?action=DepartmentUpdate",
    addDepartment: "/Data/department.ashx?action=DepartmentAdd",
    deleteDepartment: "/Data/department.ashx?action=DepartmentDelete",
    getDepartmentAndUserList: "/Data/department.ashx?action=GetDepartmentAndUserList",

    getPositionByDepartmentId: "/Data/position.ashx?action=GetPositionByDepartmentId",
    getUserAccountListByIdpaging: "/Data/department.ashx?action=GetUserAccountListByIdpaging",

    getUserBankAccountListByUserId: "/Data/user.ashx?Action=GetUserBankAccountListByUserId",
    userBankAccountAdd: "/Data/user.ashx?Action=userBankAccountAdd",
    userBankAccountDelete: "/Data/user.ashx?Action=userBankAccountDelete",

    deleteUser: "/Data/user.ashx?Action=UserDelete",
    addUser: "/Data/user.ashx?Action=UserAdd",
    UserUpdate: "/Data/user.ashx?Action=UserUpdate",

    getDepartments: "/Data/department.ashx?action=GetDepartmentprentWithChildUserCount",
    getRoles: "/Data/role.ashx?action=GetRoleList",
    deleteRole: "/Data/role.ashx?action=RoleDelete",
    getAllApplications: "/Data/role.ashx?action=GetAllApplicationParentChildList",
    roleAdd: "/Data/role.ashx?action=RoleAdd",
    roleUpdate: "/Data/role.ashx?action=RoleUpdate",
    getRoleDetailById: "/Data/role.ashx?action=GetRoleDetailById",
    getRoleApplications: "/Data/role.ashx?action=GetAllRoleApplicationListsByRoleId",
    getRoleApplicationsList: "/Data/role.ashx?action=GetAllRoleApplicationListByRoleId",
    roleApplicationAdd: "/Data/role.ashx?action=RoleApplicationAdd",
    roleApplicationUpdate: "/Data/role.ashx?action=RoleApplicationUpdate",
    getAllTasks: "/Data/role.ashx?action=TaskJSON",
    getRoleTasks: "/Data/role.ashx?action=GetTaskList",
    addRoleTask: "/Data/role.ashx?action=TaskAdd",
    saveRoleApplicationAddOnWarehouse: "/Data/role.ashx?action=roleApplicationAddOnWarehouse",
    getAllWarehouse: "/Data/Warehouse.ashx?action=warehouseAndReservoirAndStorehouserole",
    getRoleWarehouse: "/Data/role.ashx?action=getAllRoleApplicationListsByRoleId",

    getRoleListNothing: "/Data/role.ashx?action=GetRoleListNothing",
    getRoleUserListByRoleId: "/Data/role.ashx?action=GetRoleUserListByRoleId",
    addRoleUser: "/Data/role.ashx?action=RoleUserAdd",
    deleteRoleUser: "/Data/role.ashx?action=RoleUserDelete",

    getAllDictionary: "/Data/dictionary.ashx?Action=GetAllGetDictionaryList",
    getDictionaryById: "/Data/dictionary.ashx?Action=GetDictionaryDetailById",
    addDictionary: "/Data/dictionary.ashx?Action=DictionaryAdd",
    updateDictionary: "/Data/dictionary.ashx?Action=DictionaryUpdate",
    deleteDictionary: "/Data/dictionary.ashx?Action=DictionaryDelete",

    getDictionaryAreaList: "/Data/lease_order.ashx?Action=GetDictionaryAreaList",
    getProductSpecs: "/Data/product.ashx?Action=GetDictionaryStorageTypeList",
    getProductOrigins: "/Data/productOrigin.ashx?Action=getProductOriginList",
    getProductWarehouses: "/Data/Warehouse.ashx?Action=WarehouseAndReservoirAndStorehouse",

    getProductQRCode: "/Data/product.ashx?Action=GetProductQrCode",
    getSerialList: "/Data/serial_number.ashx?Action=GetSerialList",
    updateCode: "/Data/serial_number.ashx?Action=UpdateCode",
    deleteCode: "/Data/serial_number.ashx?Action=DeleteCode",
    addSerialNumer: "/Data/serial_number.ashx?Action=AddSerialNumer",
    addCardList: "/Data/supplier.ashx?Action=CustomerBankAccountAdd",
    CustomerBankAccountUpdate: "/Data/supplier.ashx?Action=CustomerBankAccountUpdate",



    getUnits: "/Data/unit_of_quantity.ashx?Action=getunit_of_quantityList",
    addUnit: "/Data/unit_of_quantity.ashx?Action=unit_of_quantityAdd",
    updateUnit: "/Data/unit_of_quantity.ashx?Action=unit_of_quantityUpdate",
    deleteUnit: "/Data/unit_of_quantity.ashx?Action=unit_of_quantityDelete",

    getSNs: "/Data/numberRule.ashx?Action=getSingleNumberRuleList",
    updateSN: "/Data/numberRule.ashx?Action=singleNumberRuleUpdate",
    getNumberRule: "/Data/numberRule.ashx?Action=getSingleNumberRuleByType",

    getProductCategories: "/Data/productCategory.ashx?Action=GetAllGetProductCategoryList",
    getProducts: "/Data/product.ashx?Action=GetProductList",
    getProductById: "/Data/product.ashx?Action=GetProductDetailById",
    addProduct: "/Data/product.ashx?Action=ProductAdd",
    updateProduct: "/Data/product.ashx?Action=ProductUpdate",
    deleteProduct: "/Data/product.ashx?Action=ProductDelete",

    getProductBrands: "/Data/productBrand.ashx?Action=getProductBrandList",
    addProductBrand: "/Data/productBrand.ashx?Action=productBrandAdd",
    updateProductBrand: "/Data/productBrand.ashx?Action=productBrandUpdate",
    deleteProductBrand: "/Data/productBrand.ashx?Action=productCategoryDelete",
    uploadProductBrandExcel: "/Data/productBrand.ashx?Action=upload",

    uploadProductListExcelJson: "/Data/product.ashx?Action=productExport",
    uploadSupplierListExcelJson: "/Data/supplier.ashx?Action=supplierExport",
    uploadCustomerListExcelJson: "/Data/supplier.ashx?Action=customerExport",
    downloadProductBrandExcelTemplate: "/PC/PCpage/template/产品品牌.xls",
    downloadProductListExcelTemplate: "/PC/PCpage/template/商品信息批量导入模版.xlsx",
    downloadSupplierListExcelTemplate: "/PC/PCpage/template/供应商信息批量导入模版.xlsx",
    downloadCustomerListExcelTemplate: "/PC/PCpage/template/客户信息批量导入模版.xlsx",
    downloadUserExcelTemplate: "/PC/DownloadTemplate/通讯录模板.xls",
    downloadOrderListExcelTemplate: "PC/PCpage/template/线索批量导入模板.xlsx",
    downloadStoreProductExcelTemplate:"/PC/PCpage/template/在库商品信息批量导入模版.xlsx",

    getSupplierTypes: "/Data/supplier.ashx?Action=GetDictionarySupplierCategoryList",
    getSuppliers: "/Data/supplier.ashx?Action=getSupplierList",
    deleteSupplier: "/Data/supplier.ashx?Action=supplierDelete",
    getSupplierById: "/Data/supplier.ashx?Action=getSupplierById",
    addSupplier: "/Data/supplier.ashx?Action=supplierAdd",
    updateSupplier: "/Data/supplier.ashx?Action=supplierUpdate",

    getSupplierBanks: "/Data/supplier.ashx?Action=GetSupplierBankAccountListBySupplierId",
    deleteSupplierBank: "/Data/supplier.ashx?Action=SupplierBankAccountDelete",
    updateSupplierBank: "/Data/supplier.ashx?Action=SupplierBankAccountUpdate",
    addSupplierBank: "/Data/supplier.ashx?Action=SupplierBankAccountAdd",

    getCustomerTypes: "/Data/supplier.ashx?Action=GetDictionaryCustomerCategoryList",
    getCustomers: "/Data/supplier.ashx?Action=getCustomerList",
    deleteCustomer: "/Data/supplier.ashx?Action=customerDelete",
    getCustomerById: "/Data/supplier.ashx?Action=getCustomerById",
    addCustomer: "/Data/supplier.ashx?Action=customerAdd",
    updateCustomer: "/Data/supplier.ashx?Action=customerUpdate",

    getCustomerBanks: "/Data/supplier.ashx?Action=GetCustomerBankAccountListByCustomerId",
    deleteCustomerBank: "/Data/supplier.ashx?Action=CustomerBankAccountDelete",
    updateCustomerBank: "/Data/supplier.ashx?Action=CustomerBankAccountUpdate",
    addCustomerBank: "/Data/supplier.ashx?Action=CustomerBankAccountAdd",

    getProductTags: "/Data/productTag.ashx?Action=getProductTagList",
    addProductTag: "/Data/productTag.ashx?Action=productTagAdd",
    updateProductTag: "/Data/productTag.ashx?Action=productTagUpdate",
    deleteProductTag: "/Data/productTag.ashx?Action=productTagDelete",

    // getMessageCode: "/Data/register.ashx?Action=GetVerificationCode",
    getMessageCode: "/api/v1/Login/SendVerificationCode",

    getRegisters:"/api/user/GetRegistList",
    auditRegister:"/api/user/audit",
    regist:"/api/user/Regist",

    getBorrowList:"/Data/lease_order.ashx?Action=GetLeaseOrderList",

    LeaseOrderList:"/Data/lease_order.ashx?Action=LeaseOrderList",
    leaseMachineList:"/Data/lease_order.ashx?Action=leaseMachineList",
    GetDictionaryCounterTypeList:"/Data/lease_order.ashx?Action=GetDictionaryCounterTypeList",





    LeaseOrderDetailById:"/Data/lease_order.ashx?Action=LeaseOrderDetailById",

    sequenceCodeUpdateForMore:"/Data/lease_order.ashx?Action=sequenceCodeUpdateForMore",
    updateSequenceCodeAddress:"/Data/lease_order.ashx?Action=updateSequenceCodeAddress",
    counterAddForMore:"/Data/lease_order.ashx?Action=counterAddForMore",




    GetMeterReadingByMachine:"/Data/lease_order.ashx?Action=GetMeterReadingByMachine",

    GetDetailByLeaseId:"/Data/lease_order.ashx?Action=GetDetailByLeaseId",

    GetAcceptListAndMaintain:"/Data/lease_order.ashx?Action=GetAcceptListAndMaintain",
    GetCounterBySequenceCodeId:"/Data/lease_order.ashx?Action=GetCounterBySequenceCodeId",




    sequenceCodeUpdateForCounter:"/Data/lease_order.ashx?Action=sequenceCodeUpdateForCounter",


    settlementMeterReadingAddForPC:"/Data/lease_order.ashx?Action=settlementMeterReadingAddForPC",

    LeaseOrderSettlement:"/Data/lease_order.ashx?Action=LeaseOrderSettlement",
    financialLeaseSettlementAddForPC:"/Data/lease_order.ashx?Action=financialLeaseSettlementAddForPC",
    getTaxRate:"/data/purchase_order.ashx?action=GetDictionaryTaxRateList",



    getWaitBorrowListx:"/Data/lease_order.ashx?Action=GetLeaseOrderStateList",
    getWaitBorrowListSecend:"/Data/lease_order.ashx?Action=GetLeaseOrderListForExecution",
    getFinacialx:"/Data/supplier.ashx?Action=GetCustomerBankAccountListByCustomerId",
    invoiceInfoUpdateX:"/Data/supplier.ashx?Action=invoiceInfoUpdate",
    invoiceInfoAdd:"/Data/supplier.ashx?Action=invoiceInfoAdd",

    getInvoiceInfoListX:"/Data/supplier.ashx?Action=getInvoiceInfoList",
    getExpressAddressListX:"/Data/supplier.ashx?Action=getExpressAddressList",
    expressAddressDeleteX:"/Data/supplier.ashx?Action=expressAddressDelete",
    expressAddressAddX:"/Data/supplier.ashx?Action=expressAddressAdd",

    CustomerBankAccountDelete:"/Data/supplier.ashx?Action=CustomerBankAccountDelete",

    GetRoleWarehouseListByUserIdNew:"/Data/Warehouse.ashx?Action=GetRoleWarehouseListByUserIdNew",
    GetRoleproductCategoryListByPutproductNew:"/Data/Warehouse.ashx?Action=GetRoleproductCategoryListByPutproductNew",

    GetDepartmentAndUserList:"/Data/department.ashx?Action=GetDepartmentAndUserList",

    //修改密码
    updatePwd:"/Data/frogetPassword.ashx?Action=updatePassword",
    //菜单目录
    getApplicationList:"/Data/role.ashx?action=GetApplicationParentChildList",
    //修改角色
    updateApplicationList:"/Data/role.ashx?action=RoleApplicationUpdate",

    //新建库区
    reservoirAdd:"/Data/Warehouse.ashx?Action=ReservoirAdd",
    //编辑库区
    reservoirUpdate:"/Data/Warehouse.ashx?Action=ReservoirUpdate",

    //获取已经新建过的最大库位编码
    getMaxStorehouseCode:"/Data/Warehouse.ashx?Action=GetMaxStorehouseCode",
    //新建库位
    storehouseAdd:"/Data/Warehouse.ashx?Action=StorehouseAdd",
    //get仓库类型
    getStoreType:"/Data/Warehouse.ashx?Action=GetDictionaryWarehouseTypeList",
    //员工批量上传
    uploadUserExcel:"/Data/user.ashx?Action=DownloadUser",
};

export const erpWebApiDic = {
    getDictionaryUserOptions: "/api/department/user_options",

    //商品维护 productV2
    addProductV2:"/api/ProductV2/Add",
    updateProductV2:"/api/ProductV2/Edit",
    deleteProductV2:"/api/ProductV2/Delete",
    getProductListV2:"/api/ProductV2/GetList",
    getDetailV2:"/api/ProductV2/GetDetail",
    getProductBrandsV2: "/api/ProductV2/GetProductBrandList",
    getProductCategoryV2:"/api/ProductV2/GetGetProductCategory",

    //客户维护 customerV2
    getCustomerListV2:"/api/CustomerV2/GetList",
    getCustomerDetailV2:"/api/CustomerV2/GetDetail",
    addCustomerV2:"/api/CustomerV2/Add",
    editCustomerV2:"/api/CustomerV2/Edit",
    deleteCustomerV2:"/api/CustomerV2/Delete",

    //供应商维护 supplier V2
    getSupplierListV2:"/api/Supplier/GetList",
    getSupplierDetailV2:"/api/Supplier/GetById",
    getSupplierStatusV2:"/api/Supplier/GetSupplierStatus",
    addSupplierV2:"/api/Supplier/Add",
    editSupplierV2:"/api/Supplier/Edit",
    editBankAcoutInfoV2:"/api/Supplier/EditBankAccountInfo",

    //仓库维护 wareHouse v2
    addWarehouseV2:"/api/WarehouseV2/Add", //新建仓库
    editWarehouseV2:"/api/WarehouseV2/Edit", //编辑仓库
    getWarehouseCodeV2:"/api/WarehouseV2/GetCode", //获取仓库编码
    getWarehouseDetailV2:"/api/WarehouseV2/GetById",//详情回显
    getStorageListV2:"/api/warehouse/GetWarehouseAndReservoirAndStorehouseListByRole",//仓库信息列表的新接口
    warehouseStartV2:"/api/WarehouseV2/Start",//启用仓库/库区/库位
    warehouseStopV2:"/api/WarehouseV2/Stop",// 停用仓库/库区/库位

    GetCode: "/api/BaseManager/GetCode", // 获取物料编码

    //以下是新仓库的接口，对应端口号8004
    getStorageProductListV2:"/8004/api/Storage/GetListStorageProduct",//在库商品列表
    uploadStorageProducts:"/8004/api/Storage/ImportStorageProduct",//在库商品的批量导入

    //获取微信授权链接
    getWxCallback:"/open/WxPlatform/GetAuthUrl",
    getAuthCode:"/open/WxPlatform/AuthorCallback",

};



// WEBPACK FOOTER //
// ./src/utils/api.js